import { useEffect } from 'react';
import useProfileStorage from '../../hooks/useProfileStorage';
import { useUTMParams } from '../UTMParamsProcessor';
import { CREATE_PROFILE_URL, getFormPayload } from './useSubmitForm';

export default function SubmitWhenUnload() {
  const { profile } = useProfileStorage();
  const utmParams = useUTMParams();
  useEffect(() => {
    function visibilityChangeHandler() {
      if (document.visibilityState === 'hidden') {
        navigator.sendBeacon(CREATE_PROFILE_URL, getFormPayload(profile, utmParams));
      }
    }
    document.addEventListener('visibilitychange', visibilityChangeHandler);
    return () => document.removeEventListener('visibilitychange', visibilityChangeHandler);
  }, [profile, utmParams]);
  return null;
}
